import React from 'react'

// prettier-ignore
export const ContractRenovation = {
  Create:    React.lazy(() => import('./create')),
  Edit:      React.lazy(() => import('./edit')),
}
